@if (showLabel) {
  <div class="flex items-center gap-2">
    <label [attr.for]="labelFor" class="m-0 flex grow items-center whitespace-normal font-semibold text-default">
      {{ label }}

      @if (required) {
        <small class="text-danger">*</small>
      }

      @if (tooltip) {
        <sb-icon class="ml-1 text-subtle" [name]="'exclamation-circle'" [size]="'lg'" [sbTooltip]="tooltip" />
      }
    </label>
    <!-- output of ngProjectAs="label-suffix" is inserted here -->
    <ng-content select="label-suffix"></ng-content>
  </div>
}

@if (hint) {
  <span class="block font-normal text-support" [innerHTML]="hint"></span>
}

<ng-content></ng-content>

@if (overrideError) {
  <span class="block text-danger">
    {{ overrideErrorMessage }}
  </span>
}

@if (control) {
  <control-messages
    class="empty:hidden"
    [ngClass]="{ hidden: hideErrorMessages || !invalid }"
    [control]="control"
    [when]="errorWhen"
    [parentCheck]="parentCheck"
    (showErrorChange)="onShowErrorChange($event)"
  />
}
